<template>
  <section>
    <div class="table-toolbar d-print-none" style="float:right">
      <a class="table-toolbar-control" @click="toolbar.open = !toolbar.open">
        <font-awesome-icon icon="bars" />
      </a>
      <div v-if="toolbar.open" class="table-toolbar-list">
        <a @click="download()">
          Download Excel
        </a>
      </div>
    </div>

    <table class="table" id="summary">
      <thead>
        <tr>
          <th colspan="2"></th>
          <th>{{ vectorName }}<br>[{{ mu }}/anno]</th>
          <th>% sul totale</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(item, i) in categories">
          <tr v-for="(row, j) in item.rows" :key="i+'-'+j">
            <template v-if="j==0">
            <th :rowspan="(item.rows.length > 1 ? item.rows.length + 1 : 1)">
              <a class="jump" v-scroll-to="scrollOptions(item.name)">{{ item.name }}</a>
            </th>
            </template>
            <td>{{ row.name }}</td>
            <td>{{ f(row.value) }}</td>
            <td>{{ f(row.perc)}}%</td>
          </tr>
          <tr class="total-row sub-total" v-if="item.total > 0 && item.rows.length > 1">
            <th>Totale {{ item.name }}</th>
            <td>{{ f(item.total) }}</td>
            <td>{{ f(item.perc) }}%</td>
          </tr>
        </template>
          <tr class="total-row">
            <th colspan="2">Totale:</th>
            <td colspan="2">{{ f(total) }}</td>
          </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import Vue from 'vue'
var VueCookie = require('vue-cookie')
var XLSX = require('xlsx')

export default {
  props: ['tep', 'vector', 'params'],

  data() {
    return {
      toolbar: { open: false },
      categories: [
        { name: 'Attività', rows: [] },
        { name: 'Servizi ausiliari', rows: [] },
        { name: 'Servizi generali', rows: [] },
        { name: 'Altro', rows: [] }],
      vectorName: "",
      mu: "",
      total: 0
    }
  },

  created() {
      this.load()
  },

  methods: {
    download() {
      let site = this.$store.state.sites.find(s => s.guid == this.params.siteGuid);
      let wb = XLSX.utils.table_to_book(document.getElementById('summary'), { sheet: "Modello energetico" })
      XLSX.writeFile(wb, this.$store.state.user.customerName + "-" + site.name +  "-modello-energetico.xlsx");
      /*
      let params = _.cloneDeep(this.params)
      params.vector = this.vector
      toolbar.open = false
      location.href = process.env.API + "/data/sankey/summary-download?token=" + VueCookie.get("token") + "&from=" + params.fromMonth + "&to=" + params.toMonth + "&site=" + this.params.siteGuid + "&vector=" + params.vector + "&parent=" + params.parent + "&categoryId=" + params.categoryId
      */
    },
    load() {

      var onlyVector = _.filter(this.tep, e => e.vector == this.vector && e.category != null)
      var onlyValues = onlyVector.map(e => e.value)
      this.total =
          _.reduce(onlyValues, function(sum, n) {
              return sum + n;
          }, 0)

      this.categories.forEach( (e, i) => {
        this.categories[i].rows = _.filter(this.tep, (v) => {
          return v.vector == this.vector && v.category == e.name
        }).map(e => {
          let item = e

          if(item.value > 0 && item.value < 0.01) {
            item.value = 0.0;
          }
          if(item.value < 0 && item.value > -0.01) {
            item.value = 0.0;
          }

          item.perc = item.value / this.total * 100
          return item
        })

        this.categories[i].total = _.reduce(this.categories[i].rows.map(e => e.value), function(sum, n) {
            return sum + n;
        }, 0)
        this.categories[i].perc = this.categories[i].total / this.total * 100
      })
      this.vectorName = this.$store.getters['vectors/getName'](this.vector)
      this.mu = this.$store.getters['vectors/getMu'](this.vector)
    },
    scrollOptions(category) {
      return {
        el: '#' + Vue.filter("slugify")(category + "-" + this.vector),
        offset: -100
      }
    },
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
  },

  watch: {
    tep() {
      this.load()
    }
  }
}
</script>

<style>
.total-row {
  font-weight: bold;
  color: #454545;
}
.table [rowspan],
.table .total-row td,
.table .total-row th {
  font-size: 13px;
}
.sub-total {
  background: #ffd6d4;
}
</style>



// WEBPACK FOOTER //
// src/components/Diagnosi/SummaryTable.vue